import React from "react";

export default function Lable(props) {
  return (
    <span
      className={`fs-8 px-2 rounded-3 ${
        props.class || "bg-light-gray"
      } position-absolute text-main`}
      style={{ top: "-8px", right: "18px" }}
    >
      {props.text}
    </span>
  );
}
